// client/src/components/influencer/InfluencerBizHeader.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllSNSCache } from '../../utils/snsAccountCache';
import { clearAllApplyCache } from '../../utils/warmApplyCache';
import { clearInfluencerContractCache } from '../../utils/influencerContractCache';
import { clearInfluencerResultCache } from '../../utils/influencerResultCache';
import { usePoints } from '../../contexts/PointContext';
import '../../styles/marketer/MarketerHeader.css'; // 전사 표준 헤더 셸 재사용 (ib-theme로 민트화)

const API_URL = process.env.REACT_APP_API_URL;

function InfluencerBizHeader({ onMenuClick }) {
	const nav = useNavigate();
	const { points, loading, isRefreshing } = usePoints();
	const goHome = () => nav('/influencer/mybiz');

	const logout = async () => {
		try {
			await fetch(`${API_URL}/api/user/logout`, { method: 'POST', credentials: 'include' });
		} catch {}
		
		// ✅ 1. 모든 캐시 초기화 (window.__ME__ 삭제 전에!)
		const uid = window.__ME__?.id;
		clearAllSNSCache();
		clearAllApplyCache();
		clearInfluencerContractCache(uid);
		clearInfluencerResultCache(uid);
		
		// ✅ 2. sessionStorage 완전 초기화
		try {
			sessionStorage.removeItem('current_user_key');
			sessionStorage.removeItem('current_user_role');
			sessionStorage.removeItem('last_login_uid'); // ✅ 보안: 마지막 로그인 uid 삭제
			
			const keys = Object.keys(sessionStorage);
			keys.forEach(key => {
				if (key.startsWith('INF_') ||
				    key.startsWith('user_points_cache_')) { // ✅ 포인트 캐시 제거
					sessionStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 3. localStorage 인플루언서 관련 캐시 초기화
		try {
			const keys = Object.keys(localStorage);
			keys.forEach(key => {
				if (key.startsWith('influencer_') || key.startsWith('inquiry_')) {
					localStorage.removeItem(key);
				}
			});
		} catch {}
		
		// ✅ 4. window.__ME__ 완전히 삭제
		if (window.__ME__) {
			delete window.__ME__;
		}
		
		// ✅ 5. warmup 타이머 정리
		if (window.__INF_WARM_TIMER) {
			clearInterval(window.__INF_WARM_TIMER);
			delete window.__INF_WARM_TIMER;
		}
		
		// ✅ 6. 페이지 새로고침으로 완전 초기화
		window.location.href = '/';
	};

	return (
		<header className="marketer-header">
			<div className="marketer-header__left">
				{onMenuClick && (
					<button className="marketer-header__menu-button" onClick={onMenuClick} aria-label="메뉴 열기">
						<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" width="22" height="22">
							<path d="M4 7h16M4 12h16M4 17h16" />
						</svg>
					</button>
				)}
				<button className="marketer-header__logo-button" onClick={goHome} aria-label="인플루언서 홈으로">
					<img
						src="/images/logo.svg"
						alt="셀프애드"
						className="marketer-header__logo"
					/>
				</button>
				<span className="marketer-header__role-tag">인플루언서</span>
			</div>

			<div className="marketer-header__right">
				{/* 포인트 표시 */}
				<div className={`marketer-header__points ${loading ? 'marketer-header__points--loading' : ''} ${isRefreshing ? 'marketer-header__points--refreshing' : ''}`}>
					보유 <b>{loading ? '...' : points.toLocaleString()}</b>P
				</div>

				<button className="marketer-header__logout" onClick={logout}>로그아웃</button>

				<span className="marketer-header__avatar" aria-hidden="true">
					<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" width="18" height="18">
						<circle cx="12" cy="8" r="4" />
						<path d="M4 21c0-4 3.6-6.5 8-6.5s8 2.5 8 6.5" />
					</svg>
				</span>
			</div>
		</header>
	);
}

export default InfluencerBizHeader;
